import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";

import { StickyItem } from "../sticky_item";
import css from "./months.module.scss";

const MIN_MONTH_WIDTH = 75;

type MonthItemProps = {
  daysOffset: number;
  monthDate: string;
  daysCount?: number;
  dayWidth: number;
};

export const MonthItem = ({ monthDate, daysOffset, daysCount, dayWidth }: MonthItemProps): JSX.Element => {
  const { formatShortMonth, utc } = useDateFormatter();

  const currentMonthDate = utc(monthDate);
  const label = `${formatShortMonth(currentMonthDate)} ${currentMonthDate.year()}`;
  const daysInMonthCount = daysCount ?? currentMonthDate.daysInMonth();
  const currentMonthWidth = daysInMonthCount * dayWidth;

  const shouldDisplayLabel = currentMonthWidth > MIN_MONTH_WIDTH;

  return (
    <div
      className={css.month}
      style={{ width: currentMonthWidth, left: daysOffset * dayWidth }}
      key={label}
      title={label}
    >
      {shouldDisplayLabel && (
        <StickyItem>
          <Typography variant="bodyBold" tag="span">
            {label}
          </Typography>
        </StickyItem>
      )}
    </div>
  );
};
